/**
 * Normalize a string by removing diacritics (accents)
 * @param str String to normalize
 * @returns Normalized string
 */
export const normalize = (str: string): string =>
  str.normalize("NFD").replace(/\p{Diacritic}/gu, "");

export const prepareHeaders = (): Record<string, string> => {
  const TOKEN = import.meta.env.VITE_API_TOKEN;

  return {
    "Content-Type": "application/json",
    accept: "application/json",
    "x-cinco-auth": `api_key`,
    Authorization: `Bearer ${TOKEN}`,
  };
};
